import { render, staticRenderFns } from "./SectionsToFinishReport.vue?vue&type=template&id=2c2c28c5&scoped=true"
import script from "./SectionsToFinishReport.vue?vue&type=script&lang=js"
export * from "./SectionsToFinishReport.vue?vue&type=script&lang=js"
import style0 from "./SectionsToFinishReport.vue?vue&type=style&index=0&id=2c2c28c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c28c5",
  null
  
)

export default component.exports